$(document).ready(function () {
  $('.product-zoom-image').on('click', function (e) {
    if ($(e.target).closest('.cloud-zoom-gallery, .sub-image, .popup-youtube').length) return;
    var $sticky = $(this).closest('.product-zoom-image.sticky');
    if ($sticky.length) {
      var $frame = $(e.target).closest('.images-container');
      var idx = $sticky.children('.images-container').index($frame);
      if (idx >= 0) $('#light-box-position').val(idx + 1);
    }
    oczoom.closeCloudZoomBig();
    oczoom.openLightBox();
  });

  document.addEventListener('click', function (e) {
    var sub = e.target && e.target.closest ? e.target.closest('.sub-image') : null;
    if (!sub) return;
    var thumbs = sub.closest('.product-vertical-thumbs');
    if (thumbs && thumbs.getAttribute('data-thumbs-drag') === '1') {
      e.preventDefault();
      e.stopPropagation();
      thumbs.removeAttribute('data-thumbs-drag');
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    oczoom.selectThumb(sub);
  }, true);

  oczoom.initAdditionalImagesOwl();
  oczoom.initMainZoomFit();
  oczoom.rememberVisibleImages();
  oczoom.setActiveThumb($('#light-box-position').val() || 1);
});

var oczoom = {
  'rebindCloudZoom': function ($main) {
    if (!$main || !$main.length || !$.fn.CloudZoom) return;
    $main.each(function () {
      var $el = $(this);
      var zoomApi = $el.data('zoom');
      if (zoomApi && typeof zoomApi.destroy === 'function') {
        try { zoomApi.destroy(); } catch (err) {}
      }
      try { $el.CloudZoom(); } catch (err) {}
    });
  },

  '_zoomImgs': {},

  'zoomFrameFrom': function (el) {
    if (!el || !el.closest) return null;
    if (!el.closest('.product-zoom-image')) return null;
    return el.closest('.images-container') || el.closest('.product-zoom-image');
  },

  'mainFromNode': function (node) {
    if (!node || !node.closest) return null;
    if (!node.closest('.product-zoom-image')) return null;
    if (node.closest('.sub-image, .cloud-zoom-gallery, .product-mosaic-item, .additional-images, .product-vertical-thumbs')) return null;
    var frame = oczoom.zoomFrameFrom(node);
    if (!frame) return null;
    return frame.querySelector('.cloud-zoom.main-image');
  },

  'insideZoomEl': function (frame) {
    if (!frame) return null;
    var big = frame.querySelector(':scope > .oc-inside-zoom');
    if (big) return big;
    big = document.createElement('div');
    big.className = 'oc-inside-zoom';
    frame.appendChild(big);
    return big;
  },

  'zoomSrc': function (el) {
    if (!el) return '';
    return el.getAttribute('data-zoom-src') || el.getAttribute('href') || '';
  },

  'largeSrc': function (url) {
    if (!url) return url;
    return url
      .replace(/_\d+x\d+(?=\.[a-zA-Z]+)/, '')
      .replace(/([?&])width=\d+/i, '$1width=2048');
  },

  'normSrc': function (url) {
    if (!url) return '';
    return String(url).replace(/^https?:/, '').replace(/^\/\//, '').split('#')[0];
  },

  'sameSrc': function (a, b) {
    if (!a || !b) return false;
    return oczoom.normSrc(a) === oczoom.normSrc(b);
  },

  // Store a frozen size snapshot, not the element: crossfade/lightbox <img>
  // nodes are reused for other slides, so a live reference would later report
  // another photo's naturalWidth/Height (hover zoom then takes its ratio).
  'rememberSrc': function (url, img) {
    if (!url || !img || !img.naturalWidth) return;
    var snap = { complete: true, naturalWidth: img.naturalWidth, naturalHeight: img.naturalHeight };
    oczoom._zoomImgs[url] = snap;
    oczoom._zoomImgs[oczoom.normSrc(url)] = snap;
  },

  'srcCached': function (url) {
    if (!url) return false;
    function ok(im) { return im && im.complete && im.naturalWidth > 0; }
    if (ok(oczoom._zoomImgs[url]) ||
        ok(oczoom._zoomImgs[oczoom.normSrc(url)]) ||
        ok(oczoom._zoomImgs[oczoom.largeSrc(url)])) {
      return true;
    }
    var nodes = document.images;
    var i, im, s, ds;
    for (i = 0; i < nodes.length; i++) {
      im = nodes[i];
      if (!ok(im)) continue;
      s = im.getAttribute('src') || im.src;
      ds = im.getAttribute('data-src');
      if (oczoom.sameSrc(s, url) || (ds && oczoom.sameSrc(ds, url))) return true;
    }
    return false;
  },

  'rememberVisibleImages': function () {
    var nodes = document.querySelectorAll('.product-zoom-image img, .product-mosaic img, .product-vertical-thumbs img, .additional-images img, .sub-image img');
    nodes.forEach(function (img) {
      var mem = function () {
        oczoom.rememberSrc(img.getAttribute('src') || img.src, img);
        if (img.getAttribute('data-src')) oczoom.rememberSrc(img.getAttribute('data-src'), img);
      };
      if (img.complete && img.naturalWidth > 0) mem();
      else img.addEventListener('load', mem, { once: true });
    });
  },

  'preloadSlide': function (url) {
    if (!url || oczoom.srcCached(url)) return;
    if (oczoom._zoomImgs[url] && !oczoom._zoomImgs[url].complete) return;
    var im = new Image();
    oczoom._zoomImgs[url] = im;
    im.onload = function () { oczoom.rememberSrc(url, im); };
    im.src = url;
  },

  'preloadAround': function (position) {
    var slides = oczoom.slides;
    if (!slides || !slides.length) return;
    var i, idx;
    for (i = -1; i <= 1; i++) {
      idx = position - 1 + i;
      if (idx < 0) idx = slides.length - 1;
      if (idx >= slides.length) idx = 0;
      if (slides[idx]) oczoom.preloadSlide(slides[idx].src);
    }
  },

  'previewReady': function (mainEl) {
    var img = mainEl && mainEl.querySelector('img:not(.oc-crossfade)');
    return !!(img && img.complete && img.naturalWidth > 0);
  },

  'hoverZoomReady': function (mainEl) {
    if (!oczoom.previewReady(mainEl)) return false;
    var href = oczoom.largeSrc(oczoom.zoomSrc(mainEl));
    return !!(href && oczoom.srcCached(href));
  },

  'preloadHoverZoom': function (mainEl) {
    if (!mainEl) return;
    var href = oczoom.largeSrc(oczoom.zoomSrc(mainEl));
    if (href) oczoom.preloadSlide(href);
  },

  'startInsideZoom': function (e, mainEl) {
    if (window.matchMedia('(max-width: 767px)').matches) return;
    var frame = oczoom.zoomFrameFrom(mainEl);
    if (!frame) return;
    var href = oczoom.largeSrc(oczoom.zoomSrc(mainEl));
    if (!href) return;
    if (!oczoom.hoverZoomReady(mainEl)) {
      oczoom.preloadHoverZoom(mainEl);
      var pending = oczoom._zoomImgs[href];
      if (pending && !pending.complete && !pending._ocHoverWait) {
        pending._ocHoverWait = true;
        pending.addEventListener('load', function () {
          pending._ocHoverWait = false;
          if (!mainEl._ocZooming) return;
          oczoom.startInsideZoom({
            clientX: mainEl._ocX || 0,
            clientY: mainEl._ocY || 0
          }, mainEl);
        }, { once: true });
      }
      return;
    }
    var big = oczoom.insideZoomEl(frame);
    oczoom.prepareZoomBg(frame, mainEl, big, href);
    if (!big._ocBg) return;
    big.style.backgroundImage = 'url("' + href.replace(/"/g, '\\"') + '")';
    big.style.display = 'block';
    oczoom.panInsideZoom(e, mainEl);
  },

  'stopInsideZoom': function (mainEl) {
    var frame = oczoom.zoomFrameFrom(mainEl);
    if (!frame) return;
    var big = frame.querySelector(':scope > .oc-inside-zoom');
    if (big) {
      big.style.display = 'none';
      big._ocBg = null;
    }
    if (mainEl) mainEl._ocZooming = false;
  },

  'prepareZoomBg': function (frame, mainEl, big, href) {
    href = href || oczoom.largeSrc(oczoom.zoomSrc(mainEl));
    var apply = function (nw, nh) {
      if (!(nw > 0) || !(nh > 0) || !big) return;
      var r = frame.getBoundingClientRect();
      var cw = r.width;
      var ch = r.height;
      if (cw < 8 || ch < 8) return;
      var cover = Math.max(cw / nw, ch / nh);
      var zoom = Math.min(cover * 2.2, Math.max(cover, 1));
      var bgW = nw * zoom;
      var bgH = nh * zoom;
      big.style.backgroundRepeat = 'no-repeat';
      big.style.backgroundSize = Math.round(bgW) + 'px ' + Math.round(bgH) + 'px';
      big._ocBg = { bgW: bgW, bgH: bgH, cw: cw, ch: ch };
    };
    var cache = oczoom._zoomImgs;
    var loader = cache[href];
    if (loader && loader.complete && loader.naturalWidth > 0) {
      apply(loader.naturalWidth, loader.naturalHeight);
      return;
    }
    loader = new Image();
    cache[href] = loader;
    loader.onload = function () {
      apply(loader.naturalWidth, loader.naturalHeight);
    };
    loader.src = href;
  },

  'panInsideZoom': function (e, mainEl) {
    var frame = oczoom.zoomFrameFrom(mainEl);
    if (!frame || !mainEl) return;
    var big = frame.querySelector(':scope > .oc-inside-zoom');
    if (!big || !big._ocBg) {
      oczoom.startInsideZoom(e, mainEl);
      return;
    }
    var r = frame.getBoundingClientRect();
    var x = (e.clientX - r.left) / r.width;
    var y = (e.clientY - r.top) / r.height;
    x = Math.min(1, Math.max(0, x));
    y = Math.min(1, Math.max(0, y));
    var b = big._ocBg;
    var extraX = Math.max(0, b.bgW - b.cw);
    var extraY = Math.max(0, b.bgH - b.ch);
    big.style.backgroundPosition = (-extraX * x) + 'px ' + (-extraY * y) + 'px';
  },

  'initMainZoomFit': function () {
    document.querySelectorAll('.product-zoom-image .cloud-zoom.main-image').forEach(function (el) {
      oczoom.preloadHoverZoom(el);
    });
    document.addEventListener('mouseover', function (e) {
      var main = oczoom.mainFromNode(e.target);
      if (!main || main._ocZooming) return;
      main._ocZooming = true;
      main._ocX = e.clientX;
      main._ocY = e.clientY;
      oczoom.startInsideZoom(e, main);
    }, true);

    document.addEventListener('mousemove', function (e) {
      var main = oczoom.mainFromNode(e.target);
      if (!main || !main._ocZooming) return;
      main._ocX = e.clientX;
      main._ocY = e.clientY;
      oczoom.panInsideZoom(e, main);
    }, true);

    document.addEventListener('mouseout', function (e) {
      var main = oczoom.mainFromNode(e.target);
      if (!main) return;
      var frame = oczoom.zoomFrameFrom(main);
      var next = e.relatedTarget;
      if (next && frame && frame.contains(next)) return;
      oczoom.stopInsideZoom(main);
    }, true);
  },

  'initAdditionalImagesOwl': function () {
    $('.additional-images.owl-carousel').not('.owl-loaded').owlCarousel({
      loop: false,
      margin: 20,
      nav: true,
      dots: false,
      responsive: {
        0: { items: 2 },
        480: { items: 3 },
        768: { items: 3 },
        992: { items: 3 },
        1200: { items: 4 }
      }
    });
  },

  'galleryNodes': function ($set) {
    if (!$set || !$set.length) return $();
    var nodes = $set.get().filter(function (el) {
      return !(el.closest && el.closest('.cloned'));
    });
    nodes.sort(function (a, b) {
      var pa = parseInt(a.getAttribute('data-pos'), 10);
      var pb = parseInt(b.getAttribute('data-pos'), 10);
      if (isNaN(pa) && isNaN(pb)) return 0;
      if (isNaN(pa)) return 1;
      if (isNaN(pb)) return -1;
      return pa - pb;
    });
    return $(nodes);
  },

  'getSlides': function () {
    var slides = [];
    var $items = oczoom.galleryNodes($('.product-mosaic-grid:visible .cloud-zoom-gallery'));
    if (!$items.length) $items = oczoom.galleryNodes($('.product-vertical-thumbs:visible .cloud-zoom-gallery'));
    if (!$items.length) $items = oczoom.galleryNodes($('.additional-images:visible .cloud-zoom-gallery'));
    if (!$items.length) $items = $('.product-zoom-image.sticky:visible .cloud-zoom.main-image');
    if (!$items.length) $items = oczoom.galleryNodes($('.additional-images .cloud-zoom-gallery'));
    $items.each(function () {
      var $el = $(this);
      var w = parseInt($el.attr('data-width'), 10);
      var h = parseInt($el.attr('data-height'), 10);
      if (!(w > 0 && h > 0)) {
        var thumb = $el.find('img')[0];
        if (thumb && thumb.naturalWidth > 0 && thumb.naturalHeight > 0) {
          w = thumb.naturalWidth;
          h = thumb.naturalHeight;
        }
      }
      if (!(w > 0 && h > 0)) {
        w = 1;
        h = 1;
      }
      slides.push({
        src: $el.attr('data-zoom-src') || $el.attr('href'),
        alt: $el.find('img').attr('alt') || $el.attr('title') || '',
        w: w,
        h: h
      });
    });
    return slides;
  },

  'getVisibleMainZoom': function () {
    var $visible = $('.product-zoom-image:visible .cloud-zoom.main-image');
    if ($visible.length) return $visible.first();
    return $('.cloud-zoom.main-image').first();
  },

  'thumbSmallImage': function (el) {
    if (!el) return '';
    var small = el.getAttribute('data-small-image');
    if (small) return small;
    var rel = el.getAttribute('rel') || '';
    var match = rel.match(/smallImage:\s*'([^']+)'/);
    if (match) return match[1];
    var img = el.querySelector('img');
    if (!img) return '';
    return img.getAttribute('src') || img.getAttribute('data-src') || '';
  },

  '_fadeMs': 300,

  'crossfadeEl': function (box) {
    if (!box) return null;
    var el = box.querySelector(':scope > .oc-crossfade');
    if (el) return el;
    el = document.createElement('img');
    el.className = 'oc-crossfade';
    el.alt = '';
    el.setAttribute('aria-hidden', 'true');
    box.appendChild(el);
    return el;
  },

  'applyMainImage': function (href, small, w, h) {
    var $main = oczoom.getVisibleMainZoom();
    if (!$main.length) return;
    var $img = $main.find('img').not('.oc-crossfade');
    var cached = !!(small && oczoom.srcCached(small));
    if (small && oczoom.sameSrc($img.attr('src'), small)) {
      if (href) {
        $main.attr('href', href);
        $main.attr('data-zoom-src', oczoom.largeSrc(href));
      }
      return;
    }
    var token = (oczoom._mainToken || 0) + 1;
    oczoom._mainToken = token;
    var box = $main.closest('.images-container')[0] || $main.closest('.product-zoom-image')[0];
    var $sk = box ? $(box).find('.product-image-skeleton') : $();
    var fade = oczoom.crossfadeEl(box);
    if (!fade || !small) return;

    function hideSk() {
      $sk.removeClass('is-visible').attr('aria-hidden', 'true');
      if (box) box.classList.add('is-loaded');
    }
    function showSk() {
      $sk.addClass('is-visible').attr('aria-hidden', 'false');
      if (box) box.classList.remove('is-loaded');
    }

    function commitMain() {
      if (href) {
        $main.attr('href', href);
        $main.attr('data-zoom-src', oczoom.largeSrc(href));
      }
      $img.attr('src', small);
      if ($img.attr('data-src')) $img.attr('data-src', small);
      w = parseInt(w, 10);
      h = parseInt(h, 10);
      if (w > 0 && h > 0) {
        if (box && !box.classList.contains('mosaic-main') && !box.classList.contains('square-frame')) {
          var ratio = w + ' / ' + h;
          box.style.setProperty('--mosaic-ratio', ratio);
          box.style.setProperty('--sticky-ratio', ratio);
        }
        $img.attr('width', w).attr('height', h);
        $main.attr('data-width', w).attr('data-height', h);
      }
      $img.removeClass('lazyload').addClass('is-shown');
      oczoom.rebindCloudZoom($main);
      oczoom.preloadHoverZoom($main[0]);
    }

    var settled = false;
    function settle() {
      if (settled || oczoom._mainToken !== token) return;
      settled = true;
      fade.removeEventListener('transitionend', onFadeEnd);
      commitMain();
      fade.style.transition = 'none';
      fade.classList.remove('is-shown');
      fade.alt = '';
      hideSk();
      requestAnimationFrame(function () {
        fade.style.transition = '';
      });
    }

    function onFadeEnd(e) {
      if (e && e.propertyName && e.propertyName !== 'opacity') return;
      settle();
    }

    function startFade() {
      if (oczoom._mainToken !== token) return;
      hideSk();
      fade.addEventListener('transitionend', onFadeEnd);
      fade.classList.add('is-shown');
      setTimeout(settle, oczoom._fadeMs + 80);
    }

    fade.classList.remove('is-shown');
    fade.style.transition = 'none';
    fade.alt = '';
    if (!cached) showSk();
    else hideSk();

    fade.onload = function () {
      if (oczoom._mainToken !== token) return;
      oczoom.rememberSrc(small, fade);
      fade.style.transition = '';
      startFade();
    };
    fade.onerror = function () {
      if (oczoom._mainToken !== token) return;
      fade.style.transition = '';
      settle();
    };
    fade.src = small;

    requestAnimationFrame(function () {
      if (oczoom._mainToken !== token) return;
      if (fade.complete && fade.naturalWidth > 0) {
        fade.onload = null;
        oczoom.rememberSrc(small, fade);
        fade.style.transition = '';
        startFade();
      }
    });
  },

  'selectThumb': function (sub) {
    if (!sub) return;
    var pos = sub.getAttribute('data-pos');
    var item = sub.closest('.item, .thumbnail, .product-mosaic-item');
    if (item && item.classList.contains('is-active')) return;
    var small = oczoom.thumbSmallImage(sub);
    var $main = oczoom.getVisibleMainZoom();
    var currentPos = $('#light-box-position').val();
    if (pos != null && String(pos) === String(currentPos) && oczoom.sameSrc($main.find('img').attr('src'), small)) return;
    if (pos != null && pos !== '') {
      $('#light-box-position').val(pos);
    }
    oczoom.applyMainImage(
      sub.getAttribute('data-zoom-src') || sub.getAttribute('href'),
      small,
      sub.getAttribute('data-width'),
      sub.getAttribute('data-height')
    );
    oczoom.setActiveThumb(pos);
  },

  'openLightBox': function () {
    var slides = oczoom.getSlides();
    if (!slides.length) { return; }
    oczoom.slides = slides;

    var startPos = parseInt($('#light-box-position').val(), 10);
    if (isNaN(startPos) || startPos < 1 || startPos > slides.length) {
      startPos = 1;
    }

    var html = '<div class="lightbox-overlay">' +
                 '<span class="lightbox-close">&times;</span>' +
                 '<span class="lightbox-prev">&#10094;</span>' +
                 '<span class="lightbox-next">&#10095;</span>' +
                 '<div class="lightbox-slide-wrapper images-container">' +
                   '<div class="product-image-skeleton"></div>' +
                   '<img class="lightbox-image" src="" alt="" />' +
                   '<img class="oc-crossfade" alt="" aria-hidden="true" />' +
                 '</div>' +
               '</div>';

    $('.lightbox-container').html(html).hide().fadeIn(300);
    $('body').css('overflow', 'hidden');

    oczoom.showSlides(startPos);
    oczoom.preloadAround(startPos);

    $('.lightbox-overlay').on('click', function (e) {
      if (e.target === this) { oczoom.closeLightBox(); }
    });
    $('.lightbox-close').on('click', function () {
      oczoom.closeLightBox();
    });
    $('.lightbox-prev').on('click', function (e) {
      e.stopPropagation();
      oczoom.plusSlides(-1);
    });
    $('.lightbox-next').on('click', function (e) {
      e.stopPropagation();
      oczoom.plusSlides(1);
    });
    $('.lightbox-image').on('click', function (e) {
      e.stopPropagation();
      if (oczoom._lbTouch && oczoom._lbTouch.dragged) {
        oczoom._lbTouch.dragged = false;
        return;
      }
      oczoom.toggleZoom(e);
    });

    $('.lightbox-slide-wrapper').on('mousemove', function (e) {
      oczoom.panImage(e);
    });
    oczoom.bindLightboxTouch();

    $(document).on('keydown.lightbox', function (e) {
      if (e.key === 'Escape') { oczoom.closeLightBox(); }
      if (e.key === 'ArrowLeft') { oczoom.plusSlides(-1); }
      if (e.key === 'ArrowRight') { oczoom.plusSlides(1); }
    });
  },

  'showSlides': function (position) {
    var slides = oczoom.slides;
    if (!slides || !slides.length) { return; }

    if (position > slides.length) { position = 1; }
    if (position < 1) { position = slides.length; }

    var slide = slides[position - 1];
    var $img = $('.lightbox-image');
    var $wrap = $('.lightbox-slide-wrapper');
    if (oczoom.sameSrc($img.attr('src'), slide.src)) {
      $('#light-box-position').val(position);
      oczoom.setActiveThumb(position);
      return;
    }

    $('#light-box-position').val(position);
    oczoom.setActiveThumb(position);

    $img.removeClass('zoomed').css('transform', '');
    $wrap.removeClass('is-zoomed');

    var token = (oczoom._showToken || 0) + 1;
    oczoom._showToken = token;
    var showing = $img.hasClass('is-shown') && !!$img.attr('src');
    var fade = $wrap.find('> .oc-crossfade')[0];
    if (!fade) {
      fade = document.createElement('img');
      fade.className = 'oc-crossfade';
      fade.alt = '';
      fade.setAttribute('aria-hidden', 'true');
      $wrap[0].appendChild(fade);
    }
    var $sk = $wrap.find('.product-image-skeleton');

    function hideSk() {
      $sk.removeClass('is-visible').attr('aria-hidden', 'true');
    }
    function showSk() {
      $sk.addClass('is-visible').attr('aria-hidden', 'false');
    }

    var settled = false;
    function settle() {
      if (settled || oczoom._showToken !== token) return;
      settled = true;
      fade.removeEventListener('transitionend', onFadeEnd);
      $img.css('transition', 'none');
      $img.attr('src', slide.src).attr('alt', slide.alt);
      oczoom.unpinLightboxImage($img);
      $img.addClass('is-shown');
      $wrap.addClass('is-loaded');
      hideSk();
      oczoom.rememberSrc(slide.src, fade);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (oczoom._showToken !== token) return;
          fade.style.transition = 'none';
          fade.classList.remove('is-shown');
          fade.alt = '';
          $img.css('transition', '');
          oczoom.preloadAround(position);
          requestAnimationFrame(function () {
            fade.style.transition = '';
          });
        });
      });
    }

    function onFadeEnd(e) {
      if (e && e.propertyName && e.propertyName !== 'opacity') return;
      settle();
    }

    function startFade() {
      if (oczoom._showToken !== token) return;
      hideSk();
      $img.removeClass('is-shown');
      $wrap.removeClass('is-loaded');
      fade.addEventListener('transitionend', onFadeEnd);
      fade.classList.add('is-shown');
      setTimeout(settle, oczoom._fadeMs + 80);
    }

    if (showing) oczoom.pinLightboxImage($img, $wrap);
    oczoom.applyLightboxFrame(slide, $wrap);
    if (showing && $wrap[0]) {
      $wrap[0].offsetWidth;
      oczoom.repositionPinnedLightboxImage($img, $wrap);
    }

    fade.classList.remove('is-shown');
    fade.style.transition = 'none';
    fade.alt = '';
    if (showing && !oczoom.srcCached(slide.src)) {
      $img.removeClass('is-shown');
      $wrap.removeClass('is-loaded');
      showSk();
    } else {
      hideSk();
    }

    fade.onload = function () {
      if (oczoom._showToken !== token) return;
      oczoom.rememberSrc(slide.src, fade);
      fade.style.transition = '';
      startFade();
    };
    fade.onerror = function () {
      if (oczoom._showToken !== token) return;
      fade.style.transition = '';
      settle();
    };
    fade.src = slide.src;

    requestAnimationFrame(function () {
      if (oczoom._showToken !== token) return;
      if (fade.complete && fade.naturalWidth > 0) {
        fade.onload = null;
        oczoom.rememberSrc(slide.src, fade);
        fade.style.transition = '';
        startFade();
      } else if (!oczoom.srcCached(slide.src)) {
        showSk();
      }
    });
  },

  'applyLightboxFrame': function (slide, $wrap) {
    if (!slide || !$wrap || !$wrap[0]) return;
    $wrap[0].style.setProperty('--lightbox-w', slide.w || 1);
    $wrap[0].style.setProperty('--lightbox-h', slide.h || 1);
    $wrap[0].style.setProperty('--lightbox-ratio', (slide.w || 1) + ' / ' + (slide.h || 1));
  },

  'pinLightboxImage': function ($img, $wrap) {
    if (!$img || !$img[0] || !$wrap || !$wrap[0]) return;
    var ir = $img[0].getBoundingClientRect();
    var wr = $wrap[0].getBoundingClientRect();
    if (ir.width < 2 || ir.height < 2) return;
    $img[0]._ocPin = { x: ir.left, y: ir.top, w: ir.width, h: ir.height };
    $img.addClass('is-pinned').css({
      width: ir.width + 'px',
      height: ir.height + 'px',
      left: (ir.left - wr.left) + 'px',
      top: (ir.top - wr.top) + 'px'
    });
  },

  'repositionPinnedLightboxImage': function ($img, $wrap) {
    if (!$img || !$img[0] || !$wrap || !$wrap[0] || !$img[0]._ocPin) return;
    var pin = $img[0]._ocPin;
    var wr = $wrap[0].getBoundingClientRect();
    $img.css({
      left: (pin.x - wr.left) + 'px',
      top: (pin.y - wr.top) + 'px'
    });
  },

  'unpinLightboxImage': function ($img) {
    if (!$img) return;
    if ($img[0]) $img[0]._ocPin = null;
    $img.removeClass('is-pinned').css({
      width: '',
      height: '',
      left: '',
      top: ''
    });
  },

  'revealLightboxImage': function ($wrap, $img) {
    if ($img && $img.length) {
      $img.addClass('is-shown').css({ visibility: '', opacity: '', transition: '' });
    }
    if ($wrap && $wrap.length) {
      $wrap.addClass('is-loaded');
      $wrap.find('.product-image-skeleton').removeClass('is-visible').attr('aria-hidden', 'true');
    }
  },

  'ensureImageShown': function ($wrap, $img) {
    if (!$img || !$img.length) return;
    var token = oczoom._showToken;
    function reveal() {
      if (oczoom._showToken !== token) return;
      var el = $img[0];
      function paint() {
        if (oczoom._showToken !== token) return;
        oczoom.rememberSrc($img.attr('src'), el);
        oczoom.revealLightboxImage($wrap, $img);
      }
      if (el && el.decode) {
        el.decode().then(paint).catch(paint);
      } else {
        paint();
      }
    }
    var el = $img[0];
    if (el && el.complete && el.naturalWidth > 0) {
      reveal();
    } else {
      $img.off('.oczoom').one('load.oczoom', reveal).one('error.oczoom', reveal);
      setTimeout(reveal, 1200);
    }
  },

  'bindLightboxTouch': function () {
    var wrap = document.querySelector('.lightbox-slide-wrapper');
    if (!wrap) return;
    oczoom._lbTouch = { startX: 0, startY: 0, dragged: false };
    wrap.addEventListener('touchstart', oczoom._onLbTouchStart, { passive: true });
    wrap.addEventListener('touchmove', oczoom._onLbTouchMove, { passive: false });
  },

  'unbindLightboxTouch': function () {
    var wrap = document.querySelector('.lightbox-slide-wrapper');
    if (wrap) {
      wrap.removeEventListener('touchstart', oczoom._onLbTouchStart);
      wrap.removeEventListener('touchmove', oczoom._onLbTouchMove);
    }
    oczoom._lbTouch = null;
  },

  '_onLbTouchStart': function (e) {
    if (!$('.lightbox-image').hasClass('zoomed')) return;
    var t = e.touches && e.touches[0];
    if (!t || !oczoom._lbTouch) return;
    oczoom._lbTouch.startX = t.clientX;
    oczoom._lbTouch.startY = t.clientY;
    oczoom._lbTouch.dragged = false;
  },

  '_onLbTouchMove': function (e) {
    if (!$('.lightbox-image').hasClass('zoomed')) return;
    var t = e.touches && e.touches[0];
    if (!t || !oczoom._lbTouch) return;
    if (Math.abs(t.clientX - oczoom._lbTouch.startX) > 8 ||
        Math.abs(t.clientY - oczoom._lbTouch.startY) > 8) {
      oczoom._lbTouch.dragged = true;
    }
    e.preventDefault();
    oczoom.panImage(t);
  },

  'toggleZoom': function (e) {
    var $img = $('.lightbox-image');
    var $wrap = $('.lightbox-slide-wrapper');

    if ($img.hasClass('zoomed')) {
      $img.removeClass('zoomed').css('transform', '');
      $wrap.removeClass('is-zoomed');
      return;
    }

    $img.addClass('zoomed');
    $wrap.addClass('is-zoomed');
    oczoom.panImage(e);
  },

'panImage': function (e) {
  var $img = $('.lightbox-image');
  if (!$img.hasClass('zoomed') || !e) { return; }

  var $wrapper = $('.lightbox-slide-wrapper');
  if (!$wrapper[0] || !$img[0]) return;
  var wrapperRect = $wrapper[0].getBoundingClientRect();
  var imgWidth = $img[0].naturalWidth;
  var imgHeight = $img[0].naturalHeight;
  var clientX = e.clientX;
  var clientY = e.clientY;
  if (clientX == null && e.touches && e.touches[0]) {
    clientX = e.touches[0].clientX;
    clientY = e.touches[0].clientY;
  }
  if (clientX == null) return;

  var x = (clientX - wrapperRect.left) / wrapperRect.width;
  var y = (clientY - wrapperRect.top) / wrapperRect.height;

  x = Math.min(Math.max(x, 0), 1);
  y = Math.min(Math.max(y, 0), 1);

  var offsetX, offsetY;

  if (imgWidth <= wrapperRect.width) {
    offsetX = -(wrapperRect.width - imgWidth) / 2;
  } else {
    offsetX = (imgWidth - wrapperRect.width) * x;
  }

  if (imgHeight <= wrapperRect.height) {
    offsetY = -(wrapperRect.height - imgHeight) / 2;
  } else {
    offsetY = (imgHeight - wrapperRect.height) * y;
  }

  $img.css('transform', 'translate(' + (-offsetX) + 'px, ' + (-offsetY) + 'px)');
},

  'plusSlides': function (n) {
    var position = parseInt($('#light-box-position').val(), 10);
    oczoom.showSlides(position + n);
  },

  // The main frame follows the last lightbox slide, as a thumbnail click would. Only where a visible thumbnail
  // drives the main frame: sticky desktop pages through its own stacked frames and has no such thumbnail.
  'syncMainToLightbox': function () {
    var pos = $('#light-box-position').val();
    if (!pos) return;
    var sub = oczoom.galleryNodes($('.sub-image[data-pos="' + pos + '"]:visible'))[0];
    if (!sub) return;
    oczoom.applyMainImage(
      sub.getAttribute('data-zoom-src') || sub.getAttribute('href'),
      oczoom.thumbSmallImage(sub),
      sub.getAttribute('data-width'),
      sub.getAttribute('data-height')
    );
    oczoom.setActiveThumb(pos);
  },

  'closeLightBox': function () {
    oczoom.syncMainToLightbox();
    oczoom.unbindLightboxTouch();
    $('.lightbox-image').removeClass('zoomed').css('transform', '');
    $('.lightbox-slide-wrapper').removeClass('is-zoomed');
    $('.lightbox-container').fadeOut(200, function () {
      $(this).html('');
    });
    $('body').css('overflow', '');
    $(document).off('keydown.lightbox');
  },

  'closeCloudZoomBig': function () {
    $('#cloud-zoom-big').hide().html('');
    $('.oc-inside-zoom').hide();
  },

  'refreshMainImageSkeleton': function () {
    if (!window.ImageSkeleton) return;
    var $main = oczoom.getVisibleMainZoom();
    var box = $main.closest('.images-container')[0] || $main.closest('.product-zoom-image')[0];
    if (!box) return;
    box.classList.remove('is-loaded');
    ImageSkeleton.reinit(box);
  },

  'setActiveThumb': function (pos) {
    var $scopes = $('.product-vertical-thumbs, .product-mosaic, .additional-images');
    if (!$scopes.length) return;
    if (pos == null || pos === '') {
      pos = parseInt($('#light-box-position').val(), 10) || 1;
    }
    $scopes.find('.item, .thumbnail, .product-mosaic-item').removeClass('is-active');
    $scopes.find('.sub-image[data-pos="' + pos + '"]').closest('.item, .thumbnail, .product-mosaic-item').addClass('is-active');
  }
};
